// extracted by mini-css-extract-plugin
export default {"AboutConference":"AboutConference_AboutConference__7didD","head":"AboutConference_head__ROK9n","contextMenu":"AboutConference_contextMenu__Z66Lj"};